import axios from "axios";

function addPadString(string, numtotalpad) {
    let strpad = "";
    if (string.length < 20) {
        for (let i = 0; i < numtotalpad - string.length; i++) {
            strpad += " ";
        }
        return strpad;
    } else {
        return "";
    }
}

var TNT = 999;
var TCL = 12;
var TCONT = 0x0d; // replaced from Francesco to 0D (2014_03_09)
var TENTER = TCONT;

var tab_scan_code_lower_case = [
    TNT,
    TNT,
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8", // 00
    "9",
    "0",
    "'",
    TNT,
    TNT,
    TNT,
    "q",
    "w",
    "e",
    "r", // 10
    "t",
    "y",
    "u",
    "i",
    "o",
    "p",
    TNT,
    "*",
    TENTER,
    TNT, // 20
    "a",
    "s",
    "d",
    "f",
    "g",
    "h",
    "j",
    "k",
    "l",
    "@", // 30
    TNT,
    TNT,
    TNT,
    ">",
    "z",
    "x",
    "c",
    "v",
    "b",
    "n", // 40
    "m",
    ";",
    ".",
    "-",
    TNT,
    "*",
    TNT,
    " ",
    TNT,
    TNT, // 50
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, // 60
    TNT,
    "7",
    "8",
    "9",
    "-",
    "4",
    "5",
    "6",
    "+",
    "1", // 70
    "2",
    "3",
    "0",
    ".",
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, // 80
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TENTER,
    TNT,
    TNT,
    TNT, // 90
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //100
    TNT,
    TCL,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //110
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //120
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //130
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //140
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //150
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //160
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //170
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //180
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //190
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //200
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //210
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //220
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //230
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //240
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //250
];

var tab_scan_code_upper_case = [
    TNT,
    TNT,
    "!",
    '"',
    "#",
    "$",
    "%",
    "&",
    "/",
    "(", // 00
    ")",
    "=",
    "?",
    TNT,
    TNT,
    TNT,
    "Q",
    "W",
    "E",
    "R", // 10
    "T",
    "Y",
    "U",
    "I",
    "O",
    "P",
    TNT,
    "+",
    TENTER,
    TNT, // 20
    "A",
    "S",
    "D",
    "F",
    "G",
    "H",
    "J",
    "K",
    "L",
    "@", // 30
    TNT,
    TNT,
    TNT,
    "<",
    "Z",
    "X",
    "C",
    "V",
    "B",
    "N", // 40
    "M",
    ",",
    ":",
    "_",
    TNT,
    "*",
    TNT,
    " ",
    TNT,
    TNT, // 50
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, // 60
    TNT,
    "7",
    "8",
    "9",
    "-",
    "4",
    "5",
    "6",
    "+",
    "1", // 70
    "2",
    "3",
    "0",
    ".",
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, // 80
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TENTER,
    TNT,
    TNT,
    TNT, // 90
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //100
    TNT,
    TCL,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //110
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //120
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //130
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //140
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //150
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //160
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //170
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //180
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //190
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //200
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //210
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //220
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //230
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //240
    TNT,
    TNT,
    TNT,
    TNT,
    TNT,
    TNT, //250
];

var stringa = "";

function filter_key(car) {
    //if (car == "\r") {
    if (car == 13) {
        console.log(stringa);
        console.log("CR");
        if (
            stringa == "=pri" ||
            stringa == "=PRI" ||
            stringa == ")pri" ||
            stringa == ")PRI"
        ) {
            doAddSellItem("Primo", 7, 1);
            stringa = "";
        }
        if (
            stringa == "=sec" ||
            stringa == "=SEC" ||
            stringa == ")sec" ||
            stringa == ")SEC"
        ) {
            doAddSellItem("Secondo", 9, 1);
            stringa = "";
        }
        if (
            stringa == "=piz" ||
            stringa == "=PIZ" ||
            stringa == ")piz" ||
            stringa == ")PIZ"
        ) {
            doAddSellItem("Pizza", 6, 1);
            stringa = "";
        }
        if (
            stringa == "=pan" ||
            stringa == "=PAN" ||
            stringa == ")pan" ||
            stringa == ")PAN"
        ) {
            doAddSellItem("Panino", 4, 1);
            stringa = "";
        }
        if (
            stringa == "=pat" ||
            stringa == "=PAT" ||
            stringa == ")pat" ||
            stringa == ")PAT"
        ) {
            doAddSellItem("Patatine", 3, 1);
            stringa = "";
        }
        if (
            stringa == "=con" ||
            stringa == "=CON" ||
            stringa == ")con" ||
            stringa == ")CON"
        ) {
            doAddSellItem("Contorno", 2, 1);
            stringa = "";
        }
        if (
            stringa == "=coc" ||
            stringa == "=COC" ||
            stringa == ")coc" ||
            stringa == ")COC"
        ) {
            doAddSellItem("Coca Cola", 2, 1);
            stringa = "";
        }
        if (
            stringa == "=caf" ||
            stringa == "=CAF" ||
            stringa == ")caf" ||
            stringa == ")CAF"
        ) {
            //  doAddSellItem('Caff&egrave;',1, 1);
            doAddSellItem("Caffè", 1, 1);
            stringa = "";
        }
        if (
            stringa == "=acq" ||
            stringa == "=ACQ" ||
            stringa == ")acq" ||
            stringa == ")ACQ"
        ) {
            doAddSellItem("Acqua", 1, 1);
            stringa = "";
        }
        var _return = stringa;
        stringa = "";
        return _return;
    } else {
        stringa = stringa + car;
        console.log(stringa);
        return "";
    }
}

export default {
    async getProducts({commit, state}) {
        commit("setSpinner", true);
        axios.post("/products", {
            "start": 0,
            "limit": 100,
            "idsalespoint": localStorage.getItem('idSalesPoint'),
            //"idcategory" : null,
            "description": state.searchstring ? state.searchstring : null,
        }).then((response) => {
            commit('setProducts', response.data.products);
            if(state.deviceProd){
                state.productDetail = state.products[0];
                commit("setShowModalDetails", true);
                state.deviceProd = false;
            }
            commit("setSpinner", false);
        }).catch((error) => {
            commit("setSpinner", false);
            console.log(error);
        });
    },


    /*async getCategories({commit,dispatch}) {
        commit("setSpinner", true);
        commit("setCategories",[]);
        commit("setIdCategory",null);
        axios.get("/categories", {
            params: {
                "start": 0,
                "limit": 100,
            }
        }).then((response) => {
            commit('setCategories', response.data.categories);
            if(response.data.categories.length) {
                commit('setIdCategory', response.data.categories[0].id);//imposto la prima categoria come quella di default
                dispatch("getProducts", {"idcategory": response.data.categories[0].id});
            }
        }).catch((error) => {
            commit("setSpinner", false);
            console.log(error);
        });
    },*/
    async getSales({commit, state}, payload) {
        commit("setSpinner", true);
        commit('setSales', []);
        axios.get("/sales", {
            params: {
                "idsalespoint": payload.search ? null : localStorage.getItem('idSalesPoint'),
                "search": state.searchsale ? state.searchsale : null,
            }
        }).then((response) => {
            //console.log(JSON.parse(JSON.stringify(response.data.sales)));
            commit('setSales', response.data.sales);
            commit('setTotalSales', response.data.totalsales);
            commit('setTotBikiniSold', response.data.totalbikini);
            commit('setTotBikiniStock', response.data.totalbikinistock);
            commit('setTotVoucher', response.data.totalvoucher);
            commit("setSpinner", false);
        }).catch((error) => {
            commit("setSpinner", false);
            console.log(error);
        });
    },
    async sendSale({commit, dispatch, state}, payload) {
        axios.post("/dosale", {
            "datetime" : payload.datetime,
            "timestamp": payload.timestamp.toString(),
            "payments": payload.payments,//è un'array
            "total": payload.totale,
            "change": payload.change,
            "discount": payload.discount,
            "voucher": payload.voucher,
            "idsalespoint": localStorage.getItem('idSalesPoint'),
            "idCashier": localStorage.getItem('idCashier'),
            "products": this.getters.getProdsReceipt,
            "manageStock": payload.manageStock ? "1" : "0",
            "fiscalReceiptNumber": payload.fiscalReceiptNumber,
            "zRepNumber": payload.zRepNumber,
        }, {}).then(response => {
            let totalf = Number(state.total).toFixed(2).replace(".", ",");
            let changef = Number(state.change).toFixed(2).replace(".", ",");
            //format total and resto on display
            let firstLine = `TOTALE${totalf} EURO`;
            let secondLine = `RESTO${changef} EURO`;

            let strpadfl = addPadString(firstLine, 20);
            let strpadsl = addPadString(secondLine, 20);

            let totalsDisplay = `<printerCommand><displayText operator="1" data="TOTALE${strpadfl}${totalf} EURORESTO${strpadsl}${changef} EURO" /></printerCommand>`;
            dispatch("sendData", {xml: totalsDisplay});
            commit('emptyReceipt');
        }).catch((error) => {
            console.log(error);
        });
    },
    //storno
    async refundSale({commit, dispatch}, payload) {
        axios.delete("/sales", {
            data: {
                "idsale": payload,
            }
        }).then((response) => {
            console.log("Lo scontrino con ID: " + payload + " è stato annullato.");
        }).catch((error) => {
            console.log(error);
        });
    },
    //reso
    async doRefund({commit, dispatch}, payload) {
        axios.post("/dorefund", {
            "idsale": this.getters.getIdSale,
            "prodsRefund": this.getters.getProdsReceipt,
        }, {}).then((response) => {
        }).catch((error) => {
            console.log(error);
        });
    },
    //cambio
    async doChange({state, commit, dispatch}, payload) {
        //const timestamp = Math.floor(new Date().getTime() / 1000).toString(); //il timestamp è già nel payload
        console.log("payload", payload);
        axios.post("/dochange", {
            "idsale": this.getters.getIdSale,
            "datetime" : payload.datetime,
            "timestamp": payload.timestamp.toString(),
            "payments": payload.payments,
            "total": payload.totale,
            "change": payload.change,
            "discount": payload.discount,
            "idsalespoint": localStorage.getItem('idSalesPoint'),
            "products": this.getters.getProdsReceipt,
            "manageStock": payload.manageStock ? "1" : "0",
            "fiscalReceiptNumber": payload.fiscalReceiptNumber,
            "zRepNumber": payload.zRepNumber,
            "idCashier": localStorage.getItem('idCashier'),
            "voucher" : payload.voucher,
            "automaticVoucher" : payload.automaticVoucher
        }, {}).then((res) => {
            let totalf = Number(state.total).toFixed(2).replace(".", ",");
            let changef = Number(state.change).toFixed(2).replace(".", ",");
            //format total and resto on display
            let firstLine = `TOTALE${totalf} EURO`;
            let secondLine = `RESTO${changef} EURO`;

            let strpadfl = addPadString(firstLine, 20);
            let strpadsl = addPadString(secondLine, 20);

            let totalsDisplay = `<printerCommand><displayText operator="1" data="TOTALE${strpadfl}${totalf} EURORESTO${strpadsl}${changef} EURO" /></printerCommand>`;
            dispatch("sendData", {xml: totalsDisplay});
            commit('emptyReceipt');
        }).catch((error) => {
            console.log(error);
        });
    },
    async getTransfers({commit, dispatch}, payload = {}) {
        commit("setSpinner", true);
        commit('setTransfers', []);
        axios.get("/transfers", {
            params: {
                "idsalespoint": localStorage.getItem('idSalesPoint'),
                "search": payload.search ? payload.search : null,
            }
        }).then((response) => {
            commit('setTransfers', response.data.transfers);
            commit("setSpinner", false);
        }).catch((error) => {
            commit("setSpinner", false);
            console.log(error);
        });
    },
    async commitTransfer({state,commit,dispatch}, payload) {
        axios.post("/transfers/commit", {
            idtransfer : payload.idtransfer
        }, {}).then((response) => {
            console.log("Trasferimento approvato con ID: " + payload.idtransfer);
            dispatch("getTransfers");
        }).catch((error) => {
            console.log(error);
        });
    },
    addProduct({state}, payload = {}) {
        let check = state.prodsReceipt.filter(prod => prod.id === payload.id);
        if (check.length === 0) {
            //prodotto non trovato, quindi lo aggiungo sia se con variante sia senza
            state.prodsReceipt.push(payload);
        } else {
            //prodotto già si trova nel conto
            let prodIndex = state.prodsReceipt.findIndex(prod => prod.id === payload.id);
            //aumento la quantità
            state.prodsReceipt[prodIndex].qnt += payload.qnt;
        }
    },
    calculateTotal({state}, payload = {}) {
        let total = 0;
        state.prodsReceipt.forEach(p => {
            p.discountprice ? total += parseFloat(p.discountprice * p.qnt) : total += parseFloat(p.price * p.qnt);
        });
        state.total = total;
    },
    async sendData({commit, dispatch, state}, payload) {
        if (payload.hidespinner) {
            commit("setSpinner", false);
        } else {
            commit("setSpinner", true);
        }
        // create SOAP envelope
        let soap = '<?xml version="1.0" encoding="utf-8"?><s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/"><s:Body>' + payload.xml + '</s:Body></s:Envelope>';
        axios.post("http://" + localStorage.getItem("ipCashier") + "/cgi-bin/fpmate.cgi?timeout=10000", soap, {
            headers: {
                "e-token": null,
                "Content-Type": "text/xml; charset=UTF-8",
                "If-Modified-Since": "Thu, 01 Jan 1970 00:00:00 GMT",
                "SOAPAction": '""'
            },
            timeout: 10000
        }).then(response => {
            //if (response.status === 200) {
            commit("setSpinner", false);
            let parser = new DOMParser();
            const resxml = parser.parseFromString(response.data, "text/xml");
            let success = resxml.getElementsByTagName("response")[0].getAttribute('success');
            //let code = resxml.getElementsByTagName("response")[0].getAttribute('code');
            //let status = resxml.getElementsByTagName("response")[0].getAttribute('status');
            if (success) {
                if (payload.type === "sale") {
                    //addInfo totali
                    let res_add = resxml.getElementsByTagName("response")[0].getElementsByTagName('addInfo');
                    let tag_names_array = "";
                    let add_info = "";
                    if (res_add.length > 0) {
                        let list = res_add[0].getElementsByTagName('elementList');
                        let tag_names_list = list[0].childNodes[0].nodeValue;
                        tag_names_array = tag_names_list.split(',');
                        add_info = {};

                        for (let i = 0; i < tag_names_array.length; i++) {
                            let node = res_add[0].getElementsByTagName(tag_names_array[i])[0];
                            let node_child = node.childNodes[0];
                            add_info[tag_names_array[i]] = node_child.nodeValue;
                        }
                    }
                    //converto data e ora dello scontrino
                    let datetime = null;
                    if(add_info.fiscalReceiptDate !== undefined && add_info.fiscalReceiptTime !== undefined){
                        let dateTimeString = add_info.fiscalReceiptDate + " " + add_info.fiscalReceiptTime;
                        // Dividi la stringa in data e orario
                        let [data, ora] = dateTimeString.split(' ');

                        // Ulteriore divisione per giorno, mese, anno
                        let [giorno, mese, anno] = data.split('/').map(num => num.padStart(2, '0'));

                        // Divisione e formattazione dell'orario
                        let [ore, minuti] = ora.split(':').map(num => num.padStart(2, '0'));

                        // Composizione della data e orario nel formato desiderato
                        datetime = `${giorno}/${mese}/${anno} ${ore}:${minuti}`;
                    }
                    //let printertimestamp = Date.parse(date + " " + time + ":00") / 1000;
                    //effettuo la vendita, il reso o il cambio
                    let sale = {
                        "datetime" : datetime,
                        "timestamp": payload.timestamp,
                        "manageStock": payload.manageStock,
                        "payments": payload.payments,
                        "totale": payload.total.toString(),
                        "discount": payload.discount ? payload.discount.toString() : "0",
                        "change": payload.change ? payload.change.toString() : "0",
                        "fiscalReceiptNumber": add_info.fiscalReceiptNumber,
                        "zRepNumber": add_info.zRepNumber,
                        "voucher" : payload.voucher,
                        "automaticVoucher" : payload.automaticVoucher
                    };
                    if (state.exchange) {
                        //qua ho l'idSale nel vuex della vendita da cambiare
                        dispatch("doChange", sale);
                        commit('setExChange', false);
                    } else {
                        console.log("sale", sale);
                        dispatch("sendSale", sale);
                    }
                } else if (payload.type === "refund") {
                    //ritorno nello stato a 0
                    let xml = '<printerCommand><clearText operator="1" /><resetPrinter operator="1" /></printerCommand>';
                    dispatch("sendData", {xml: xml});
                    dispatch("doRefund", {
                        "idsale": payload.idsale,
                    });
                    commit('setStatusRefund', false);
                    commit("setSellsAlert", false);
                    commit('emptyReceipt');
                } else if (payload.type === "storno") {
                    dispatch("getSales");
                }
            }
        }).catch(error => {
            console.log(error.message);
            commit("setSpinner", false);
            alert("Attenzione: controllare la connessione con la stampante fiscale.");
            if (error.code === 'ECONNABORTED') {
                console.log('Request timed out');
            } else {
                console.log(error.message);
            }
        });
    },
    async createDeviceScanner({commit, dispatch, state}, payload) {
        try {
            let url = 'ws://' + localStorage.getItem("ipCashier") + ':8008/connect';
            state.socket = new WebSocket(url);
            state.socket.onopen = function (ev) {
                console.log('CONNECTED');
                state.sockconn = true;
            };
            state.socket.onclose = function (ev) {
                console.log('DISCONNECTED');
                state.sockconn = false;
            };
            state.socket.onerror = function (ev) {
                console.log('ERROR');
                state.sockconn = false;
            };
            state.socket.onmessage = function (event) {
                console.log('MESSAGE');
                let data = JSON.parse(event.data);
                let header = data[0];
                switch (header) {
                    case "open_device":
                        //il dispositivo è connesso
                        if (data[2] === "OK") {
                            //device connesso
                            commit("setDeviceConn", true);
                            console.log("DEVICE CONNESSO");
                        } else {
                            commit("setDeviceConn", false);
                            console.log("DEVICE NON CONNESSO");
                        }
                        break;
                    case "close_device":
                        console.log(data);
                        break;
                    case "device_data":
                        let car;
                        let stream = data[3];
                        if (isNaN(stream.data4)) {
                            console.log("Data not a number");
                        } else {
                            if (stream.data2 === 1) {
                                car = tab_scan_code_upper_case[stream.data4];
                                console.log("Shift pressed; car = " + car);
                            } else {
                                car = tab_scan_code_lower_case[stream.data4];
                                console.log("Shift not pressed; car = " + car);
                            }
                            //quello che arriva dallo scanner
                            let string_from_scanner = filter_key(car);
                            if (string_from_scanner !== "") {
                                if (string_from_scanner.length !== 10) {
                                    state.searchstring = string_from_scanner;
                                    if(string_from_scanner.length === 13 || string_from_scanner.length === 12){
                                        state.deviceProd = true;
                                        dispatch("getProducts");
                                    }else {
                                        dispatch("getProducts");
                                    }
                                } else {
                                    //timestamp
                                    state.searchsale = string_from_scanner;
                                    commit("setSellsAlert", true);
                                    dispatch("getSales", {search: true});
                                }
                            }
                        }
                        break;
                    case "error":
                        console.log("ERROR: " + data);
                        break;
                    default:
                        break
                }
            };
        } catch (error) {
            console.log(error.message);
        }
    },
    async sendDataScanner({commit, dispatch, state}) {
        try {
            state.socket.send(JSON.stringify([
                "open_device",
                "local_scanner",
                {"type": "type_scanner", "crypto": false}
            ]));
        } catch (error) {
            console.log(error.message);
        }
    },
    async closeSocket({state}, payload) {
        state.socket.close();
        state.sockconn = false;
    },
    setQntReceipt({state, dispatch, commit}, payload) {
        switch (payload.action) {
            case "+" : {
                if(state.exchange){
                    //se è un cambio
                    //se change è a true vedo lo stock altrimenti la qnt
                    if(state.prodsReceipt[payload.index]["change"] &&
                        state.prodsReceipt[payload.index]["qnt"] + 1 > state.prodsReceipt[payload.index].stock){
                        commit("setShowAlertStock", true);
                        commit('setMessage', "Il prodotto non ha disponibilità a magazzino.");
                    }else if(!state.prodsReceipt[payload.index]["change"] &&
                        state.prodsReceipt[payload.index]["qnt"] + 1 > state.prodsReceipt[payload.index].beforeqnt){
                        commit("setShowAlertStock", true);
                        commit('setMessage', "Il prodotto non ha disponibilità a magazzino.");
                    }else{
                        state.prodsReceipt[payload.index]["qnt"] += 1;
                        commit("setShowAlertStock", false);
                    }
                }else{
                    //non è un cambio quindi vedo solo la quantità in base allo stock dentro prodsReceipt
                    if(state.prodsReceipt[payload.index]["qnt"] + 1 > state.prodsReceipt[payload.index].stock){
                        commit("setShowAlertStock", true);
                        commit('setMessage', "Il prodotto non ha disponibilità a magazzino.");
                    }else{
                        state.prodsReceipt[payload.index]["qnt"] += 1;
                        commit("setShowAlertStock", false);
                    }
                }
            }break;
            case "-" : {
                if (state.prodsReceipt[payload.index]["qnt"] - 1) {
                    state.prodsReceipt[payload.index]["qnt"] -= 1;
                    commit("setShowAlertStock", false);
                }
            }break;
        }
        //stampa su display il nome e il prezzo del prodotto
        let product = state.prodsReceipt[payload.index];
        let prodname = state.prodsReceipt[payload.index].description;
        let secondLine = `${Number(product.price * product.qnt).toFixed(2).toString().replace(".", ",")} EURO`;
        let strpad = "";
        let numtotalpad = 20;
        let max_item_desc_len = 17;
        if (secondLine.length < 20) {
            for (let i = 0; i < numtotalpad - secondLine.length; i++) {
                strpad += " ";
            }
        } else {
            strpad = "";
        }
        if (prodname.length < max_item_desc_len) {
            //forzare la lunghezza di max_item_desc_len mettendo gli spazi se necessario
            prodname = prodname + "                 "; // lunghezza massima della stampante è 17 caratteri senza la quantità
            prodname = prodname.substring(0, max_item_desc_len);
        } else {
            prodname = prodname.slice(0, max_item_desc_len); // Troncare la stringa
        }
        let messageDisplay = `<printerCommand><displayText operator="1" data="x${product.qnt} ${prodname}${strpad}${secondLine}" /></printerCommand>`;

        dispatch("sendData", {xml: messageDisplay, hidespinner: true});//metto a true perché non mi devo aspettare results dalla stampante
        dispatch("calculateTotal");
    }
}